module.exports = __webpack_public_path__ + "static/media/img04.16a1163c.webp";